import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import { ConfirmationService, MessageService } from 'primeng/api';
import { retry } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import * as CryptoJS from "crypto-js";
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { SchoolFpgDataVO } from 'src/app/shared/models/SchoolFPGDataVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
//import { Usuario } from 'src/app/shared/models/Usuario';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';


@Component({
  selector: 'app-supplierlst',
  templateUrl: './supplierlst.component.html',
  styleUrls: ['./supplierlst.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SupplierlstComponent implements OnInit {

  vwsupplId: string;
  vwaddress: string;
  vwemail1: string;
  vwemail2: string;
  vwmobPhon: string;
  vwname: string;
  vwsendEmail: string;
  vwshortName: string;
  vwstatus: string;
  vwstoreId: string;
  vwsuppType: string; 

  /** Security */
  currentUser: any;
  security: SecurityDocument;

  /** Labels */
  lbl_go_Back: string = "back_";
  lbl_total: string = "total_";
  lbl_records: string = "records_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_login: string = "Login_";
  lbl_name: string = "name_";
  lbl_last_name: string = "last_name_";
  lbl_type: string = "type_";
  lbl_guideId: string = "guideId_";
  lbl_email: string = "email_";
  lbl_vendor: string = "vendor_";
  lbl_edit: string = "edit_";
  lbl_delete_record: string = "delete_record_";
  lbl_users: string = "users_";
  lbl_new_record: string = "new_record_";
  lbl_save: string = "save_";
  lbl_back: string = "back_";
  lbl_detail: string = "detail_";
  lbl_user: string = "user_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_";
  lbl_address: string = "address_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_search: string = "search_";
  lbl_send: string = "send_";
  lbl_short_Name: string = "short_Name_";
  lbl_storeId: string = "storeId_";
  lbl_loading: string = "loading_";

     //Supplier
  Supplier: any;

  tmpPassword: string;

  
  //usuarioDocList: Usuario[];
        //Suppliers
  lstData: any[];
  
  lstGuides: any[];
  selectedGuide: any;
  filteredGuides: any[];
  showGuides: boolean;

  lstSuppliers: any[];
  selectedSupplier: any;
  showSuppliers: boolean;


  //selectedUsuario: Usuario;
  //selectedlogin: Usuario[];


  optionDialog: boolean;
  submitted: boolean;
  mailValid: boolean;

  //userView: Usuario;
  dataView: any;


  listLanguage: CategoryLan[];
  selectedLanguage: CategoryLan;
  listFunctions: CategoryLan[];
  selectedFunction: CategoryLan;
  listUserTypes: any[];
  selectedUserType: any;
  blocked: boolean = true;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadSupplier();
    this.getSecurity(); 
    
  }

  loadSupplier() {
    this.blocked = true;

    this.apiService.getAllSupplier()
      .then(responseData => {
        this.lstData = responseData;
        // Data manipulation similar to lstCordinationCatalog
        //const listSuppiers = this.lstData.filter( (data) => data.status == "A");
        const listSuppiers = this.lstData.filter( (data) => data.status == "A");
        this.lstData = listSuppiers;
      })
      .finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  hideDialog() {
    this.optionDialog = false;
    this.submitted = false;
  }

  newSupplier() {
    //this.dataView = {};
   this.vwsupplId = '';
   this.vwaddress = '';
   this.vwemail1 = '';
   //this.vwemail2 = '';
   //this.vwmobPhon = '';
   this.vwname = '';
   this.vwsendEmail = '';
   this.vwshortName = '';
   //this.vwstatus = '';
   this.vwstoreId = '';
   this.vwsuppType = '';

    this.submitted = false;
    this.optionDialog = true;
   // this.showGuides = true;
   // this.showSuppliers = false;
   // this.tmpPassword = null;
   // this.selectedGuide = {};
   // this.selectedSupplier = {};
  }

  editSupplier(data: any) {
   // this.dataView = { ...data };
   this.vwsupplId = data.supplId;
   this.vwaddress = data.address;
   this.vwemail1 = data.email1;
   //this.vwemail2 = data.email2;
   //this.vwmobPhon = data.mobPhon;
   this.vwname = data.name;
   this.vwsendEmail = data.sendEmail;
   this.vwshortName = data.shortName;
   this.vwstatus = data.status;
   this.vwstoreId = data.storeId;
   this.vwsuppType = data.suppType;

  this.optionDialog = true;
  }
  createSupplier() {
    this.submitted = true;

    //if (this.dataView.status) {
      if (this.vwstatus) {

      this.apiService.updateSupplier(
        //this.dataView
        {
          "supplId": this.vwsupplId,
          "address": this.vwaddress,
          "email1": this.vwemail1,
          //"email2": this.vwemail2,
          //"mobPhon": this.vwmobPhon,
          "name": this.vwname,
          "sendEmail": this.vwsendEmail,
          "shortName": this.vwshortName,
          "status": this.vwstatus,
          "storeId": this.vwstoreId,
          "suppType": this.vwsuppType,
        }
        
        ).then(
        data => {
          if (data && data.vwstatus && (data.vwstatus == Constants.EXCEPTION_ERROR || data.vwstatus == Constants.ERRORSTATUS)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
          } else {
            this.loadSupplier();
            this.optionDialog = false;
            //this.dataView = {};
           this.vwsupplId = '';
           this.vwaddress = '';
           this.vwemail1 = '';
           //this.vwemail2 = '';
           //this.vwmobPhon = '';
           this.vwname = '';
           this.vwsendEmail = '';
           this.vwshortName = '';
           //this.vwstatus = '';
           this.vwstoreId = '';
           this.vwsuppType = '';
            this.messageService.add({ severity: 'success', summary: 'Datos actualizados', detail: ' ', life: 3000 });
          }
        })

    } else {

      //this.dataView.status = "A";
      this.vwstatus = "A";

      this.apiService.createSupplier(
        //this.dataView
        {
          "supplId": this.vwsupplId,
          "address": this.vwaddress,
          "email1": this.vwemail1,
          //"email2": this.vwemail2,
          //"mobPhon": this.vwmobPhon,
          "name": this.vwname,
          "sendEmail": this.vwsendEmail,
          "shortName": this.vwshortName,
          "status": this.vwstatus,
          "storeId": this.vwstoreId,
          "suppType": this.vwsuppType,
        }

        ).then(
        data => {
          if (data && data.vwstatus && data.errorMessage && (data.vwstatus == Constants.EXCEPTION_ERROR || data.vwstatus == Constants.ERRORSTATUS)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
          } else {
            this.optionDialog = false;

            //this.dataView = {};
            this.vwsupplId = '';
            this.vwaddress = '';
            this.vwemail1 = '';
            //this.vwemail2 = '';
            //this.vwmobPhon = '';
            this.vwname = '';
            this.vwsendEmail = '';
            this.vwshortName = '';
            this.vwstatus = '';
            this.vwstoreId = '';
            this.vwsuppType = '';
            this.messageService.add({ severity: 'success', summary: 'Datos Actualizados', detail: ' ', life: 3000 });
            this.loadSupplier();
          }
        }).catch(error => {
          console.error(error);
          this.messageService.add({ severity: 'error', summary: 'Se presentó algun error', detail: error, life: 9000 });
        });
    }
    //this.loadSupplier();
  }
  
  deleteSupplier(data: any) {
    this.confirmationService.confirm({
      message: '¿ ' + this.lbl_are_you_sure + ' ' + this.lbl_delete_record + ' ' + this.lbl_user + ' ' + data.login + ' ?',
      header: this.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      accept: () => {
        this.apiService.deleteSupplier(data).then(
          data => {

            this.messageService.add({ severity: 'success', summary: 'Eliminar Opción', detail: 'Se elimino opción correctamente', life: 3000 });
            this.loadSupplier();

          });
      }
    });
  }
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
          //this.lstSuppliersBySupStoreId();

        });
    } else {
      this.getTranslatedLabels();
    }
  }
  
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_total, this.lbl_records, this.lbl_showing, this.lbl_of, this.lbl_login, this.lbl_name, this.lbl_last_name, this.lbl_type, this.lbl_guideId, this.lbl_email, this.lbl_vendor, this.lbl_edit, this.lbl_delete_record, this.lbl_users, this.lbl_new_record, this.lbl_save, this.lbl_back, this.lbl_detail, this.lbl_user, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_yes, this.lbl_no, this.lbl_address, this.lbl_cell_phone, this.lbl_search, this.lbl_send, this.lbl_short_Name, this.lbl_storeId, this.lbl_loading]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_login = map.get(this.lbl_login);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_last_name = map.get(this.lbl_last_name);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_vendor = map.get(this.lbl_vendor);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_users = map.get(this.lbl_users);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_detail = map.get(this.lbl_detail);
        this.lbl_user = map.get(this.lbl_user);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);
        this.lbl_address = map.get(this.lbl_address);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_short_Name = map.get(this.lbl_short_Name);
        this.lbl_storeId = map.get(this.lbl_storeId);
        this.lbl_loading = map.get(this.lbl_loading);


      });
  }

  goBack() {
    window.close();
  }

  exportPdf() {
    if (this.lstData === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstData.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstData.map((item) => ({

        "SUPPLY_ID": item ? (item?.supplId || 'S/N') : 'S/N',
        "NAME": item ? (item?.name || 'S/N') : 'S/N',
        "ADDRESS ": item ? (item?.address || 'S/N') : 'S/N',
        "SUPP_TYPE": item ? (item?.suppType || 'S/N') : 'S/N',
        "MOB_PHON": item ? (item?.mobPhon || 'S/N') : 'S/N',
        "EMAIL": item ? (item?.email1 || 'S/N') : 'S/N',
        
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listSuppliers_');

    }
  }
  exportExcel() {
    if (this.lstData === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstData.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstData.map((item) => ({
        "SUPPLY_ID": item ? (item?.supplId || 'S/N') : 'S/N',
        "NAME": item ? (item?.name || 'S/N') : 'S/N',
        "ADDRESS ": item ? (item?.address || 'S/N') : 'S/N',
        "SUPP_TYPE": item ? (item?.suppType || 'S/N') : 'S/N',
        "MOB_PHON": item ? (item?.mobPhon || 'S/N') : 'S/N',
        "EMAIL": item ? (item?.email1 || 'S/N') : 'S/N',
      }));

      this.filesService.tovpilExportXLSX(filteredJSON, 'listSuppliers_');

    }
  }
  
}

